import { Input } from "@/components/ui/input";
import { useDebounce } from "@/hooks/use-debounce";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useEffect, useRef, useState } from "react";
import {
  setHotelFilters,
  useHotelFilter,
} from "../../state/extract-hotel-filter-slice";
import { HotelAccordion } from "./hotel-accordion";

export const HotelNameFind = () => {
  const dispatch = useAppDispatch();
  const { selectedOption } = useAppSelector(useHotelFilter);
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );
  const selected = selectedOption?.hotelName;

  const [search, setSearch] = useState<string | undefined>(selected);
  const debounceValue = useDebounce(search, 500);
  const lastDispatched = useRef<string | undefined>(selected);

  useEffect(() => {
    if (debounceValue !== undefined) {
      if (debounceValue) {
        lastDispatched.current = debounceValue;
        dispatch(setHotelFilters({ hotelName: debounceValue }));
      } else {
        lastDispatched.current = undefined;
        dispatch(setHotelFilters({ hotelName: undefined }));
      }
    }
  }, [debounceValue, dispatch]);

  useEffect(() => {
    // Only update search text if Redux was changed EXTERNALLY (like by clicking Clear Filter)
    if (selected !== lastDispatched.current) {
      setSearch(selected || "");
      lastDispatched.current = selected;
    }
     
  }, [selected, search]); // keeping 'search' in dependency to avoid Fast Refresh crash caused by changing array length

  return (
    <HotelAccordion value={"hotel_name"} label={"Find Hotel by Name"}>
      <>
        <Input
          className=""
          disabled={isLoading}
          placeholder="Find hotel by name"
          onChange={(e) => setSearch(e.target.value)}
          value={search || ""}
        />
      </>
    </HotelAccordion>
  );
};

HotelNameFind.displayName = "HotelNameFind";
